import { stringifyFiltersToSearchParams } from '@pesto/utils';

import type { ListCardsQueryVariables, ListUsersQueryVariables } from '../__generated__/graphql/api';

import { routes } from './routes';

export const USERS_DEFAULT_FILTERS: Partial<ListUsersQueryVariables> = {
  isFriendsAndFam: false,
};

export const CARDS_DEFAULT_FILTERS: Partial<ListCardsQueryVariables> = {
  userIsFriendsAndFam: false,
};

export const USERS_DEFAULT_HREF = `${routes.users}?${stringifyFiltersToSearchParams(USERS_DEFAULT_FILTERS)}`;

export const CARDS_DEFAULT_HREF = `${routes.cards}?${stringifyFiltersToSearchParams(CARDS_DEFAULT_FILTERS)}`;

export const LOANS_DEFAULT_HREF = routes.loans;
